import { useEffect, useState } from 'react';

/**
 * Hook to detect scroll state of an element.
 * Returns whether the element has scrollable content and if it's scrolled to the bottom.
 */
export function useScrollDetection(contentRef) {
  let dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const [hasScroll, setHasScroll] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);
  useEffect(() => {
    const checkScroll = () => {
      if (contentRef.current) {
        const {
          scrollHeight,
          clientHeight,
          scrollTop
        } = contentRef.current;
        const hasScrollableContent = scrollHeight > clientHeight;
        setHasScroll(hasScrollableContent);

        // Check if scrolled to bottom (with a small threshold for better UX)
        const isScrolledToBottom = scrollTop + clientHeight >= scrollHeight - 5;
        setIsAtBottom(isScrolledToBottom);
      }
    };
    const handleScroll = () => {
      checkScroll();
    };
    checkScroll();
    const resizeObserver = new ResizeObserver(checkScroll);
    const currentContentRef = contentRef.current;
    if (currentContentRef) {
      resizeObserver.observe(currentContentRef);
      currentContentRef.addEventListener('scroll', handleScroll);
    }
    window.addEventListener('resize', checkScroll);
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', checkScroll);
      if (currentContentRef) {
        currentContentRef.removeEventListener('scroll', handleScroll);
      }
    };
  }, [contentRef, ...dependencies]);
  return {
    hasScroll,
    isAtBottom
  };
}